// @flow

import axios from "axios";
import { COMMON_HEADERS } from "./restApi";
import { RestFetchApi } from "./restFetchApi";
import {
    buildAxiosConfigWithHeaders,
    buildAxiosQueryConfigWithHeaders,
} from "./restApiRequestConfig.ts";

import type { ApiClient, RequestHeaders } from "./restApi";

/** ApiClient that uses axios library underneath */
export class ApiClientAxios implements ApiClient {
    axiosInstance: axios.AxiosInstance;
    fetchInstance: ApiClient;

    constructor() {
        this.axiosInstance = axios.create({
            headers: COMMON_HEADERS,
        });
        this.fetchInstance = new RestFetchApi();
    }

    get(url: string, params?: any, headers?: RequestHeaders): Promise<any> {
        const config = buildAxiosQueryConfigWithHeaders(params, headers);
        return this.axiosInstance.get(url, config);
    }

    post(url: string, body: any, headers?: RequestHeaders): Promise<any> {
        if (url.startsWith("/api/v1.0/reports/quick-simulation-sync")) {
            return this.fetchInstance.post(url, body, headers);
        }

        const config = buildAxiosConfigWithHeaders(headers);
        return this.axiosInstance.post(url, body, config);
    }

    put(url: string, body: any, headers?: RequestHeaders): Promise<any> {
        const config = buildAxiosConfigWithHeaders(headers);
        return this.axiosInstance.put(url, body, config);
    }

    delete(url: string, params?: any, headers?: RequestHeaders): Promise<any> {
        const config = buildAxiosQueryConfigWithHeaders(params, headers);
        return this.axiosInstance.delete(url, config);
    }

    setRequestHeader(key: string, val: string | null): void {
        this.axiosInstance.defaults.headers.common[key] = val;
        this.fetchInstance.setRequestHeader(key, val);
    }

    /** Allow access to underlaying instance for setting interceptors */
    getAxiosInstance(): axios.AxiosInstance {
        return this.axiosInstance;
    }

    abort(): void {
        if (this.fetchInstance) {
            this.fetchInstance.abort();
        }
    }
}
